import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { AdOrder } from '@/api/types/ads.types';
import { QUERY } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';

export function useOrderChange() {
  const router = useRouter();

  const handleChangeOrder = useCallback(
    (newOrder: AdOrder) => {
      const { pathname, query } = router;

      router.push({
        pathname,
        query: {
          ...query,
          order: newOrder.toLowerCase(),
          [QUERY.keywords_source]: KeywordsSource.Typewritten,
        },
      });
    },
    [router]
  );

  return handleChangeOrder;
}
